const commandList = [
    "echo",
    "open",
    "theme"
]

export default commandList